import { create } from "zustand";


export const useArticleStore = create((set) => ({
	disabled: false,

	setDisabled: (disabled) => set(() => ({ disabled }))
}));